// src/components/SocialSidebar.js
import React from "react";
import { Box, IconButton } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";

const SocialSidebar = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        left: 20,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        zIndex: 999,
      }}
    >
      <IconButton
        href="https://wa.me/+256705332050"
        target="_blank"
        sx={{
          color: "wheat",
          backgroundColor: "#1e242c",
          "&:hover": { transform: "scale(1.2)" },
        }}
      >
        <WhatsAppIcon />
      </IconButton>
      <IconButton
        href="https://www.instagram.com/sruhad.inv"
        target="_blank"
        sx={{
          color: "wheat",
          backgroundColor: "#1e242c",
          "&:hover": { transform: "scale(1.2)" },
        }}
      >
        <InstagramIcon />
      </IconButton>

      <IconButton
        href="https://www.facebook.com/sruhad.inv/"
        target="_blank"
        sx={{
          color: "wheat",
          backgroundColor: "#1e242c",
          "&:hover": { transform: "scale(1.2)" },
        }}
      >
        <FacebookIcon />
      </IconButton>
    </Box>
  );
};

export default SocialSidebar;
